import React from 'react';

interface SegmentedControlProps {
  options: { label: string; value: string }[];
  selectedValue: string;
  onValueChange: (value: string) => void;
  className?: string;
}

export const SegmentedControl: React.FC<SegmentedControlProps> = ({
  options,
  selectedValue,
  onValueChange,
  className = ''
}) => {
  return (
    <div
      role="tablist"
      className={`inline-flex h-[42px] bg-muted p-[3px] rounded-lg ${className}`}
      data-name="segmented control"
    >
      {options.map((option) => {
        const isSelected = option.value === selectedValue;
        return (
          <button
            key={option.value}
            role="tab"
            aria-selected={isSelected}
            onClick={() => onValueChange(option.value)}
            className={`w-1/2 h-full flex items-center justify-center px-5 rounded-md font-sans font-semibold text-sm leading-none tracking-[-0.14px] whitespace-nowrap cursor-pointer transition-all duration-150 ease-[cubic-bezier(0.25,0.46,0.45,0.94)] outline-none focus-visible:ring-2 focus-visible:ring-ring ${
              isSelected
                ? 'bg-background text-foreground border border-black/20 shadow-[0_1px_2px_rgba(0,0,0,0.06)]'
                : 'bg-transparent text-muted-foreground border border-transparent hover:bg-black/[0.04]'
            }`}
            data-name="segmented control item"
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default SegmentedControl;
